import { BASE_URL_PROD } from '../config/keys';
import React,{ useEffect,useState,useRef }  from "react";
import { useTranslation } from 'react-i18next';
import './styles.scss';

import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux"

import { defaultimg } from "../../assets/images";
import { Nav,Card} from "react-bootstrap";
import { BiMap,BiShoppingBag,BiUserCircle,BiHistory,BiUser,BiLogInCircle,BiHeart,BiMoney,BiCalendarCheck ,BiFolderPlus,BiCog,BiMessageRoundedDots,BiAward,BiFolderOpen,BiCreditCard} from 'react-icons/bi';
import { LOGOUT_USER ,SET_FORMULE} from "../../constants/actions";
import { changepicture } from "../../actions/mixedmode";

const Component = ({ slug }) => {
    const history = useHistory();
    const {user} = useSelector(state => state.user)
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const fileInput = useRef(null)

     useEffect(() => {
          
        if (!user.user_id || user.google_id!='A') {
           history.replace("/")
        }

        
                if (user?.active===0) {
                      history.replace('/client/validation/') 
                }
               

           

    }, [user.user_id])

    const handleClick = (src) => {
         history.push(src);
    }
       const handleLogout = () =>{
        dispatch({ type: SET_FORMULE, payload: {} })
        dispatch({type:LOGOUT_USER});

    }

  const handleClickfile = () => {
      fileInput.current.click()
  }

  const handleFileChange = event => {
       
      const formData =  new FormData();
      formData.append('image',event.target.files[0]);
      formData.append('token',user.api_token);
      formData.append('api_token',user.api_token);
      console.log("formData",formData)
      dispatch(changepicture(formData));
     
  }



 



    return (

      <div className='menudash'>

      <div onClick={()=>setValue(!value)} className="mob-nav-content-btn color2-bg init-dsmen fl-wrap "><i className="fa fa-bars" style={{marginLeft: '10px',    marginRight: '10px'}}></i>{t('nav.menu')}</div>

             <Card  className={value==1 ? 'menudashitems' :'menudashitems mndbnone'} >
              
        
              {(user.picture=="" || !user.picture) && <div variant="top" style={{cursor:'pointer',width:100,height:100,borderRadius:50,backgroundPosition: 'center',backgroundSize: 'cover',backgroundRepeat: 'no-repeat',alignSelf: 'center' ,marginTop:20,backgroundImage:`url(${defaultimg})`}} onClick={() => handleClickfile()}  ></div>}
              {user.picture && <Card.Img onClick={() => handleClickfile()}  style={{cursor:'pointer',width:100,height:100,backgroundImage:`url(${BASE_URL_PROD + "gestion/public/uploads/"+user.picture})`,borderRadius:50,backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',alignSelf: 'center' ,marginTop:20}} />}
               <form style={{padding:'0px'}}>
               <input
               style={{display:'none'}}
                type="file"
                accept='image/*'
                onChange={(e) => handleFileChange(e)}
                ref={fileInput} 
            />
            </form>


                  <Card.Body>
                    <Card.Title className='text-center'>{user.first_name} {user.last_name} </Card.Title>
                    <Card.Text>
                  
                    </Card.Text>
                  <Nav defaultActiveKey="/home" className="flex-column nav-style">

                  <Nav.Link   onClick={()=>handleClick('/client/mesrendezvous')} className={slug=='mesrendezvous' && "active"} ><BiCalendarCheck  size={20} />{t('appointment.my_appointments')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/abonnement')} className={slug=='abonnement' && "active"} ><BiAward  size={20} />{t('subscription.title')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/moyens-de-paiement')} className={slug=='moyens-de-paiement' && "active"} ><BiCreditCard  size={20} />{t('payment.my_payment_methods')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/profile')}  className={slug=='profile' && "active"}><BiUserCircle   size={20} />{t('profile.my_profile')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/dossier-patient')} className={slug=='dossierpatient' && "active"} ><BiFolderPlus  size={20} />{t('patient.my_file')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/documents')} className={slug=='documents' && "active"} ><BiFolderOpen  size={20} />{t('patient.my_documents')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/messages')} className={slug=='messages' && "active"} ><BiMessageRoundedDots  size={20} />{t('messaging.title')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/parametres')} className={slug=='parametres' && "active"} ><BiCog  size={20} />{t('profile.settings')}</Nav.Link>
                  <Nav.Link   onClick={()=>handleClick('/commandes')} className={slug=='commandes' & "active"} ><BiShoppingBag  size={20} />{t('cart.my_orders')}</Nav.Link>                 
                  <Nav.Link   onClick={()=>handleClick('/adresses')} className={slug=='adresses' && "active"} ><BiMap  size={20} />{t('cart.delivery_address')}</Nav.Link>
                  <Nav.Link    onClick={()=>handleClick('/mes-articles-favoris')} className={slug=='favoris' && "active"} ><BiHeart   size={20} />{t('cart.my_favorites')}</Nav.Link>
                  <Nav.Link    onClick={()=>handleClick('/parrainage')} className={slug=='parrainage' && "active"} ><BiHistory   size={20} />{t('profile.referral')}</Nav.Link>
                  <Nav.Link  onClick={()=>handleClick('/reclamations')} className={slug=='reclamations' && "active"}  ><BiUser   size={20} />{t('patient.leave_complaint')}</Nav.Link>
                </Nav>

                <div className='logout'>
                     <button className="logout_btn color2-bg" onClick={handleLogout}>{t('auth.logout')} <BiLogInCircle color={"#FFF"} size={20} /></button>
                </div>

                
                  </Card.Body>
                </Card>

            </div>
    );
}

export default Component;